import { Navigate } from "react-router-dom";
import { ROUTES } from "@/consts";
import { useAuth } from "@/contexts";
import { getFirstAllowedRoute } from "@/services/auth/permissions";
import NotAuthorized from "@/services/auth/NotAuthorized";

const HomeRedirect = () => {
	const {
		state: { token, user },
	} = useAuth();

	if (!token) {
		return <Navigate to={ROUTES.Login} replace />;
	}

	// DefaultLayout renders routes only after the profile loads
	if (!user) {
		return null;
	}

	const homeRoute = getFirstAllowedRoute(user.permissions);
	if (!homeRoute) {
		return <NotAuthorized />;
	}

	return <Navigate to={homeRoute} replace />;
};

export default HomeRedirect;
